var currentTier;

class VIPTiers {
    constructor(vipTiers, baseTier, vipTiersSetting, customer) {
        this.baseTier = baseTier;
        this.vipTiers = [this.baseTier, ...vipTiers];
        this.vipTiersSetting = vipTiersSetting;
        this.customer = customer;
    }
    renderVIPTiers() {
        $(".swell-vip-tiers-setting").append(
            $("<div>").addClass("swell-table-benefitts").append(
                $("<div>").addClass("tier-current"),
                $("<p>").text("").addClass("swell-vip-tier-require-points"),
                $("<p>").text("BENEFITS"),
                $("<p>").text("Multiplier")),
            $("<div>").addClass("swell-table-vip-tiers"))
        this.vipTiers.forEach((vipTier, index1) => {
            if (vipTier.pointsMultiplier[vipTier.pointsMultiplier.length - 1] == '0') {
                vipTier.pointsMultiplier = vipTier.pointsMultiplier.substring(0, vipTier.pointsMultiplier.length - 2)
            }
            $(".swell-table-vip-tiers").append(
                $("<div>").addClass("swell-table-tier").append(
                    $("<div>").addClass("tier-current"),
                    $("<p>").addClass("swell-vip-tier-require-points"),
                    $("<p>").text(vipTier.name).addClass("swell-tier-name").append(
                        $("<div>").addClass("tier-require-purchase")),
                    $("<p>").text(`${vipTier.pointsMultiplier}X`)
                ))
            if (index1 == 1) {
                $(`.swell-table-tier:nth-of-type(${index1+1}) .tier-require-purchase`).text("Make 1 Purchase")

            }
            if (index1 == 2) {
                $(`.swell-table-tier:nth-of-type(${index1+1}) .tier-require-purchase`).text("Make 4 Purchases")

            }

            this.vipTiersSetting.forEach((vipTierSet, index2) => {
                $(`.swell-table-tier:nth-of-type(${index1+1})`).append(
                    $("<p>").text(vipTierSet.option[`${index1+1}`]))
                if (vipTierSet.option[`${index1+1}`] === "✓") {
                    $(`.swell-table-tier:nth-of-type(${index1+1}) p:nth-of-type(${index2+4})`).text("").append(
                        $("<img>")
                        .addClass(`swell-tier-img${index1}`).addClass("swell-tier-img").attr("alt", "Swell Tier"))
                }
            })

        })
        this.vipTiersSetting.forEach((vipTierSet, ) => {
            $(".swell-table-benefitts").append(
                $("<p>").text(vipTierSet.option[0]))
        })
        this.generateTierStatusPointer();
        console.log(currentTier);
        var newscript = document.createElement('script');
        newscript.type = 'text/javascript';
        newscript.async = true;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(newscript);
        $(".swell-table-vip-tiers").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            //nextArrow: '<img class="slick-next slick-arrow next-btn" src="//thebeardclub.com/cdn/shop/t/733/assets/swell-next-img.svg?v=19332900683711950881765999352"></img>',
            //nextArrow: '<img class="slick-next slick-arrow next-btn" src="//thebeardclub.com/cdn/shop/t/733/assets/swell-next-img.svg?v=19332900683711950881765999352"></img>',
            //prevArrow: '<img class="slick-prev slick-arrow prev-btn"  src="//thebeardclub.com/cdn/shop/t/733/assets/swell-prev-img.svg?v=14274176036398406391765999353"></img>',
            responsive: [{
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false,
                        initialSlide: currentTier
                    }
                },
                {
                    breakpoint: 653,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        initialSlide: currentTier
                    }
                },
            ]
        });
    }
    generateTierStatusPointer() {
        let vipTiers = swellAPI.getVipTiers().sort((a, b) => a.swellrequiredPointsEarned - b.swellrequiredPointsEarned);

        if (this.customer.created_at !== undefined) {
            currentTier = null;
            this.customer.vipTier === null ? currentTier = 0 : currentTier = this.vipTiers.map(tier => tier.name).indexOf(this.customer.vipTier.name);
            $(`.swell-table-tier:nth-of-type(${currentTier + 1}) .tier-current`).text("Current Status").addClass("swell-tier-current-status");
            $(`.swell-table-tier:nth-of-type(${currentTier + 1}) .swell-tier-name`).addClass("current-text")
            let customerCurrentTierIndex = swellAPI.getCustomerDetails().vipTier === null ? -1 : swellAPI.getVipTiers().map(tier => tier.name).indexOf(swellAPI.getCustomerDetails().vipTier.name);
            if (customerCurrentTierIndex + 1 < swellAPI.getVipTiers().length) {
                $(".current-text").append($("<div>").css("color", "black").text(`Make ${(vipTiers[customerCurrentTierIndex + 1].swellrequiredPurchasesMade - swellAPI.getCustomerDetails().vipTierStats.purchasesMade)} more purchase${(vipTiers[customerCurrentTierIndex + 1].swellrequiredPurchasesMade - swellAPI.getCustomerDetails().vipTierStats.purchasesMade) == 1 ? "" : "s"} to earn ${(vipTiers[currentTier].name)}`))
                //where to add it?
            }
        }
    }
}
